import { createContext, useContext, useEffect, useState } from 'react';

const CookieConsentContext = createContext();

export const CookieConsentProvider = ({ children }) => {
  const [isConsentGiven, setIsConsentGiven] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent !== null) {
      setIsConsentGiven(consent === 'true');
      setShowPopup(false);
    } else {
      setShowPopup(true);
    }
  }, []);

  const acceptCookies = () => {
    setIsConsentGiven(true);
    setShowPopup(false);
    localStorage.setItem('cookieConsent', 'true');
  };

  const declineCookies = () => {
    setIsConsentGiven(false);
    setShowPopup(false);
    localStorage.setItem('cookieConsent', 'false');
  };

  return (
    <CookieConsentContext.Provider
      value={{ isConsentGiven, showPopup, acceptCookies, declineCookies }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => useContext(CookieConsentContext);